var _a;
import { ofType } from "redux-observable";
import { EMPTY, of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { catchError, map, switchMap, switchMapTo } from "rxjs/operators";
import { mockLoginRequest } from "../../__mock__/mockAuth";
import { utilEnvironment } from "../../utils/utilEnvironment";
import { TypeActionApp } from "../app/actionApp";
import { TypeActionEnvSelect } from "../env-select/actionEnvSelect";
import { actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { IdStatusClientGateway } from "./IdStatusClientGateway";
export var GameUrlByStatus = new Map([
    [IdStatusClientGateway.Production, process.env.REACT_APP_GAME_URL_PRODUCTION],
    [IdStatusClientGateway.Approval, process.env.REACT_APP_GAME_URL_APPROVAL],
    [IdStatusClientGateway.HotFix, process.env.REACT_APP_GAME_URL_HOTFIX],
    [IdStatusClientGateway.Integration, process.env.REACT_APP_GAME_URL_INTEGRATION],
]);
export var NotificationUrlByStatus = new Map([
    [IdStatusClientGateway.Production, process.env.REACT_APP_NOTIFICATIONSERVER_URL_PRODUCTION],
    [IdStatusClientGateway.Approval, process.env.REACT_APP_NOTIFICATIONSERVER_URL_APPROVAL],
    [IdStatusClientGateway.HotFix, process.env.REACT_APP_NOTIFICATIONSERVER_URL_HOTFIX],
    [IdStatusClientGateway.Integration, process.env.REACT_APP_NOTIFICATIONSERVER_URL_INTEGRATION],
]);
// const ChatServerUrlByStatus = new Map<IdStatusClientGateway, any>([
//     [IdStatusClientGateway.Production, process.env.REACT_APP_CHATSERVER_URL_PRODUCTION],
//     [IdStatusClientGateway.Approval, process.env.REACT_APP_CHATSERVER_URL_APPROVAL],
//     [IdStatusClientGateway.HotFix, process.env.REACT_APP_CHATSERVER_URL_HOTFIX],
//     [IdStatusClientGateway.Integration, process.env.REACT_APP_CHATSERVER_URL_INTEGRATION],
// ]);
var UnderMaintenanceStatuses = [
    IdStatusClientGateway.ApprovalMaintenance,
    IdStatusClientGateway.ProductionMaintenance,
];
// const urlTemplate = "http://localhost:1337/v1/get/gameId/38/clientVersion/{{version}}?platform=1";
var urlTemplate = process.env.REACT_APP_CLIENT_GATEWAY_URL || "";
var url = urlTemplate.replace("{{version}}", mockLoginRequest.clientVersion.toString(10));
var headers = (_a = {},
    _a["Content-Type"] = "text/plain;charset=UTF-8",
    _a);
export var epicClientGatewayProduction = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionApp.Init), switchMapTo(ajax({
        async: true,
        crossDomain: true,
        headers: headers,
        method: "GET",
        responseType: "text",
        url: url,
    })), catchError(function () { return of(actionModalOpen(IdModal.Maintenance)); }), map(function (response) {
        return response.response;
    }), switchMap(function (status) {
        var underMaintenance = UnderMaintenanceStatuses.indexOf(status) !== -1;
        if (underMaintenance) {
            return of(actionModalOpen(IdModal.Maintenance));
        }
        var endpoint = GameUrlByStatus.get(status);
        var notificationEndPoint = NotificationUrlByStatus.get(status);
        // const chatServerEndPoint = ChatServerUrlByStatus.get(status);
        if (endpoint != undefined) {
            deps.netConnect(endpoint);
            deps.notificationNetConnect(notificationEndPoint);
            // deps.chatNetConnect(chatServerEndPoint);
            return EMPTY;
        }
        // Seems like user is either using an outdated client, or getting IdStatusClientGateway.BadRequest
        // Anyhow we should ask them to reload
        return of(actionModalOpen(IdModal.ManualUpdate));
    }));
};
export var epicClientGatewayDevelopment = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionEnvSelect.Select), switchMap(function (action) {
        // let chatServerEndPoint = ChatServerUrlByStatus.get(action.environment);
        var environment = utilEnvironment.isStaging()
            ? IdStatusClientGateway.Approval
            : action.environment;
        var endpoint = GameUrlByStatus.get(environment);
        var notificationEndpoint = NotificationUrlByStatus.get(environment);
        // chatServerEndPoint = ChatServerUrlByStatus.get(environment);
        // Marco's local server
        // endpoint = "ws://10.0.109.138:8888";
        // Dominik's local server
        // endpoint = "ws://10.0.35.149:8888";
        deps.netConnect(endpoint);
        deps.notificationNetConnect(notificationEndpoint);
        // deps.chatNetConnect(chatServerEndPoint);
        return EMPTY;
    }));
};
export var epicClientGatewayMaintenance = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionApp.Init), switchMapTo(of(actionModalOpen(IdModal.Maintenance))));
};
var epic = epicClientGatewayProduction;
if (!utilEnvironment.isProduction()) {
    epic = epicClientGatewayDevelopment;
}
export var epicClientGateway = epic;



//////////////////
// WEBPACK FOOTER
// ./src/features/client-gateway/epicClientGateway.ts
// module id = 825
// module chunks = 3